// test934
(934 && 0);
